<template>
    <div v-show="!$store.state.queries_expanded" @click="$store.state.queries_expanded = ~$store.state.queries_expanded"
        class="hndl nousersel" v-bind:class="bordload">&gt;</div>
    <div v-show="$store.state.queries_expanded" @click="$store.state.queries_expanded = ~$store.state.queries_expanded"
        class="hndl2 nousersel">&lt;</div>
    <div v-show="$store.state.queries_expanded" class="queryholder">
        <div v-if="$store.state.query_manager && Object.keys($store.state.query_manager.queries).length == 0">
            No running requests
        </div>
        <div v-if="$store.state.query_manager && Object.keys($store.state.query_manager.queries).length > 0">
            <div class="queryitem" v-bind:title="vget(quev, 'reason')"
                v-for="(quev, queidx)  in Object.values($store.state.query_manager.queries).sort(query_sort())"
                :key="queidx">
                <span v-bind:title="vget(quev, 'reason')"
                    v-show="!(vget(quev, 'status') == ENUMS.QUERY_ITEM_STATUS.DONE)">{{ vget(quev, "polls") }} / 13
                </span>
                <span>
                    <LoadingComp v-show="vget(quev, 'status') == ENUMS.QUERY_ITEM_STATUS.LOADING"
                        style="transform:  scale(-0.15) translate(-42px,-35px);max-height: 20px;max-width: 20px;">
                    </LoadingComp>
                    <div v-bind:title="vget(quev, 'reason')"
                        v-show="vget(quev, 'status') == ENUMS.QUERY_ITEM_STATUS.DONE">✅</div>
                    <div v-bind:title="vget(quev, 'reason')"
                        v-show="vget(quev, 'status') == ENUMS.QUERY_ITEM_STATUS.FAIL">❌</div>

                </span>
                <span v-bind:title="vget(quev, 'reason')">{{ quev.mcmd }}</span>

            </div>
        </div>
    </div>
</template>
<script>

import ENUMS from './Enums';
import LoadingComp from './LoadingComp.vue';
import { vget, query_sort } from '@/utility'


export default {
    name: ENUMS.VIEWS.QUERY,
    components: {
        LoadingComp
    }, mounted() {
        var qthis = this
        if (this.minterval == undefined) {
            this.minterval = setInterval(() => {
                if (qthis.$store.state.query_manager.has_loading()) {
                    qthis.bordload = "bordload" + this.bordloadcnt
                } else {
                    qthis.bordload = ""

                }
                this.bordloadcnt += 1
                this.bordloadcnt %= 4

            }, 500);
        }
    }
    , data: function () {

        return {
            ENUMS: ENUMS
            , bordload: ""
            , bordloadcnt: 0
            , minterval: undefined
        }
    }, methods: {
        vget, query_sort
    }
}
</script>

<style scoped>
.queryholder {

    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    flex-wrap: wrap;
    top: 18%;
    left: 0;
    width: 200px;
    height: 65%;
    background-color: rgb(24, 24, 24, 0.9);
    border: solid;
    border-left-color: white;
    border-left: 0;

    z-index: 900;

}

.queryitem2 {
    background: rgba(22, 245, 36, 1);
    background: linear-gradient(90deg, rgba(176, 250, 188, 1) 0%, rgba(22, 245, 36, 1) 35%, rgba(55, 150, 56, 1) 100%);
    border-style: solid;
    border-width: 2px;
    border-color: black;
    margin-bottom: 1%;
    z-index: 900;

}

.queryitem {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;

}

.hndl {
    background-color: black;
    position: fixed;
    left: 0px;
    top: 50%;
    font-size: 40pt;
    border-style: solid;
    border-color: white;
    /* border-top-right-radius: 50%;
    border-bottom-right-radius: 50%; */
    border-left: 0;
    z-index: 900;

}

.bordload1 {
    /* border-top-color: red; */
    color: red;
}

.bordload2 {
    /* border-right-color: red; */
}

.bordload3 {
    /* border-bottom-color: red; */
    color: red;

}

.bordload0 {
    /* border-left-color: red; */
}

.hndl2 {
    background-color: black;
    position: fixed;
    left: 200px;
    top: 50%;
    font-size: 40pt;
    border-style: solid;
    border-color: white;
    z-index: 900;

}
</style>